import axios from "axios";
import React, { useEffect, useState } from "react";
import ImgOptimized from "../../../../../components/ImgOptimized";
import { getUpdatedImageUrlWithSize } from "../../../../../utils/helpers";
import { Box, Button } from "@chakra-ui/react";
import classNames from "classnames";

const normalizeProjectImageMaterials = (projectImageMaterials) => {
  if (!Array.isArray(projectImageMaterials)) {
    return [];
  }

  return projectImageMaterials.flatMap((entry) => {
    if (!entry || typeof entry !== "object") {
      return [];
    }

    if (typeof entry.image === "string") {
      return [entry];
    }

    return Object.values(entry).filter(
      (value) =>
        value && typeof value === "object" && typeof value.image === "string",
    );
  });
};

const Step03_SelectImage = ({
  nextStep,
  state,
  projectId,
  selectedProjectImage,
  setSelectedProjectImage,
}) => {
  const [imgs, setImgs] = useState(null);
  const fetchProjectImgs = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACK_URL}/api/project-showcases/images/${projectId}`,
      );
      setImgs(response.data);
      window.scrollTo(0, 0); // Scroll to top on project load
    } catch (error) {
      console.error("Failed to fetch project data", error);
    }
  };
  useEffect(() => {
    fetchProjectImgs();
  }, [projectId]);

  const imageMaterialCounts = normalizeProjectImageMaterials(
    imgs?.projectImageMaterials,
  ).reduce((counts, item) => {
    counts[item.image] = Array.isArray(item.materials)
      ? item.materials.length
      : 0;
    return counts;
  }, {});

  return (
    <div className="">
      {imgs && (
        <div>
          {/* <h2>{imgs.title}</h2> */}
          <div className="grid grid-cols-2 gap-4 h-full min-h-0 mt-2">
            {(imgs.sliderImages || []).map((img, index) => (
              <div
                key={img || index}
                className={classNames({
                  "relative overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-all": true,
                  "border-4 border-teal-500 shadow-md":
                    selectedProjectImage === img,
                })}
              >
                {!!imageMaterialCounts[img] && (
                  <div
                    className="absolute left-1.5 top-1.5 z-10 min-w-[24px] h-6 px-2 rounded-md flex items-center justify-center text-[11px] font-semibold text-white tracking-wide"
                    style={{
                      background: "rgba(0, 0, 0, 0.55)",
                      backdropFilter: "blur(8px)",
                      WebkitBackdropFilter: "blur(8px)",
                      border: "1px solid rgba(255, 255, 255, 0.18)",
                      boxShadow:
                        "0 2px 12px rgba(0,0,0,0.25), inset 0 1px 0 rgba(255,255,255,0.1)",
                      letterSpacing: "0.04em",
                    }}
                  >
                    {imageMaterialCounts[img]}
                  </div>
                )}
                <ImgOptimized
                  onClick={() =>
                    setSelectedProjectImage(
                      img,
                      getUpdatedImageUrlWithSize(
                        `${process.env.REACT_APP_BACK_URL}/api/minio/${img}`,
                        [2, 2, 3],
                      ),
                    )
                  }
                  className={`rounded-xl w-full h-full object-cover cursor-pointer`}
                  src={getUpdatedImageUrlWithSize(
                    `${process.env.REACT_APP_BACK_URL}/api/minio/${img}`,
                    [2, 2, 3],
                  )}
                  alt="Section main"
                />
              </div>
            ))}
          </div>
          <Box position={"sticky"} bottom={0} w={"100%"} pt={2} bg={"white"}>
            <Button
              disabled={!selectedProjectImage}
              w={"100%"}
              colorScheme="teal"
              onClick={nextStep}
            >
              Next Step
            </Button>
          </Box>
        </div>
      )}
    </div>
  );
};

export default Step03_SelectImage;
